import script from "./ReturnScan.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturnScan.vue?vue&type=script&setup=true&lang=js"

import "./ReturnScan.vue?vue&type=style&index=0&id=6e374ee8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3689317901/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-prod-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e374ee8"]])

export default __exports__